"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _claimsClient = _interopRequireDefault(require("../../clients/claimsClient"));

var _merchantConfigClient = _interopRequireDefault(require("../../clients/merchantConfigClient"));

var _clients = require("../../constants/clients");

var useClient = function useClient(_ref) {
  var environment = _ref.environment,
      accessToken = _ref.accessToken,
      clientType = _ref.clientType;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      client = _useState2[0],
      setClient = _useState2[1]; // If any of client config props change, we need to get a new client


  (0, _react.useEffect)(function () {
    // The minimum required to create a client
    if (accessToken && clientType) {
      switch (clientType) {
        case _clients.FULFILLER_CLAIMS:
          setClient(new _claimsClient["default"]({
            environment: environment,
            accessToken: accessToken
          }));
          break;

        case _clients.MERCHANT_CONFIG:
          setClient(new _merchantConfigClient["default"]({
            environment: environment,
            accessToken: accessToken
          }));
          break;

        default: // no-op

      }
    }

    return function () {
      if (client) {
        client.cancel();
      }
    };
  }, [environment, accessToken, clientType]);
  return client;
};

var _default = useClient;
exports["default"] = _default;